import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from '@angular/core';
import { WizBaseView, WizRoot, WizEventManager, WizEvent, WizCommand, WizGroupCommand } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE, CmdErrorMessage, PopMaker, SocketIOService, ViewData } from '@wizeoo/akm-common-lib';
import { AllkeyWebWorker } from '@wizeoo/akm-common-lib';
import { Model } from './model/model';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { BreakpointObserver } from '@angular/cdk/layout';

/** racine applicative. Toujours présente */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends WizBaseView implements OnInit {
  constructor(public elementRef: ElementRef, private breakpointObserver: BreakpointObserver) {
    super(elementRef);

    // on signale qu'on est en mode spécif
    WizRoot.specifMode = true;
    // et en mode mobile
    WizRoot.mobileMode = true;

    // injection des variables de style
    // couleur de sélection dans les listes
    document.documentElement.style.setProperty('--item-selected', '#a8800899');
    document.documentElement.style.setProperty('--selected-background-color', '#a8800899');
    // hover et fond des zones de saisie
    document.documentElement.style.setProperty('--item-hover', '#ebcb6bFF');

    // remplacement du violet... par du noir
    document.documentElement.style.setProperty('--item-purple', '#000000');
    // bas de zones de saisie
    document.documentElement.style.setProperty('--border-bottom', '#8C8C8C99');
    // surcharge des boutons save
    document.documentElement.style.setProperty('--item-green', '#08ad26ff');

  }

  wizBeforeInit(): boolean | Promise<any>[] | WizGroupCommand | WizCommand<any> {
    
    // détection du mode
    // this.feedMode();
    
    // console.log('ngOnInit');
    window.addEventListener('beforeinstallprompt', (e) => {
        console.log('beforeinstallprompt', e);
        // Empêche l'affichage automatique de la bannière
        e.preventDefault();
    });
    return true;
  }

  // feedMode(): void {
  //   this.breakpointObserver.observe([
  //   Breakpoints.Handset,
  //   Breakpoints.Tablet,
  //   Breakpoints.Web
  // ]).subscribe(result => {
  //   if (result.breakpoints[Breakpoints.Handset]) {
  //     console.log('Mobile');
  //   } else if (result.breakpoints[Breakpoints.Tablet]) {
  //     console.log('Tablet');
  //   } else {
  //     console.log('Desktop');
  //   }
  // });
  // }


  // écouteur websocket
  public socketIOService: SocketIOService;

  public wizSynchronizeData() {

    // signaler que la vue root est UP
    ViewData.getInstance().rootViewInitComplete.next(true); 

    // écouteur sur navigation pour gestion des pops left / right
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_SET_VIEW, Model.getInstance().navigationEngine.addView.bind(Model.getInstance().navigationEngine));
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_UNREGISTER, Model.getInstance().navigationEngine.removeView.bind(Model.getInstance().navigationEngine));

    // écouteur global sur le changement de vision
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, Model.getInstance().userContextService.onVisionChanged.bind(Model.getInstance().userContextService) ); 
    
    // écouteur global pour forcer le reload
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.COMPOSITE_RELOAD, Model.getInstance().compositeEngine.compositeReload.bind(Model.getInstance().compositeEngine) ); 
    
    // interception et affichage des erreurs de service
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.CMD_ERR, this.onCommandError);
    
    // demande d'ouverture de popUp par les widgets
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SHOWPOP, PopMaker.openMassPop);

 
    // initialisation du socketIo
    this.socketIOService = new SocketIOService(Model.getInstance());

    // écouteurs sur websocket
    this.socketIOService.onAKMMessage().subscribe((message: any) => {
      Model.getInstance().socketMessageEngine.do(Model.getInstance().navigationEngine.getCurrentView(), message);
    });


    if(Model.getInstance().connectedUser.mail.indexOf("wizeoo") > -1) {
      WizRoot.verboseMode = true;
    }
  }

  /**
   * interception des erreurs de service
   */
  private onCommandError(e: WizEvent): void {
    // console.log('cmd error', e.value.error);
    CmdErrorMessage.doMessage(e);
  }

}

/** construction du webWorker */
if (typeof Worker !== 'undefined') {

  const worker = new Worker(new URL('./manager/worker/app.worker', import.meta.url));
  AllkeyWebWorker.webworker = worker;

  AllkeyWebWorker.webworker.postMessage({type:'INIT'});
} else {
  console.log('Web Workers are not supported in this environment');
  // Web Workers are not supported in this environment.
}